// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterStyle_container__Oye5T","partOne":"FooterStyle_partOne__26JNp","icons":"FooterStyle_icons__1iZ41","partTwo":"FooterStyle_partTwo__3z8hL"};